import React from 'react';
import { classList } from 'utils/componentsCommon';

const ContentBoxText = ( { children, className, ...props }) => {
    const classNames = classList(
        'contentBoxText',
        className);

    return <section className={ classNames } { ...props }>
        { children }
    </section>;
};

export default ContentBoxText;
